import React, { Component } from 'react';
import M from  'materialize-css/dist/js/materialize.min.js';
import 'materialize-css/dist/css/materialize.min.css';
import '../Css/Style.css';

class AddMember extends Component{

    componentDidMount(){
        var elems = document.querySelectorAll('select');
        M.FormSelect.init(elems, {});
    }


    state={
        firstName:"",
        lastName:"",
        email:"",
        mobile:"",
        Username: "",
        role:"",


        firstName_err:"",
        lastName_err: "",
        email_err:"",
        mobile_err:"",
        Username_err:"",
        role_err:""
 };
 
validate =()=>{

    if(this.state.firstName===""){
        this.setState({
            firstName_err:'* empty First Name! *'
        })
    }
    else{
        this.setState({
            firstName_err:''
        });
    }
    if(this.state.lastName===""){
        this.setState({
            lastName_err:'* empty Last Name! *'
        })
    }
    else{
        this.setState({
            lastName_err:''
        });
    }
    if(this.state.email===""){
        this.setState({
            email_err:'* empty  Email! *'
        })
    }
    else{
        this.setState({
            email_err:''
        });
    }
    if(this.state.mobile===""){
        this.setState({
            mobile_err:'* empty Mobile Number! *'
        })   
    }
    else{
        this.setState({
            mobile_err:''
        });
    }
    
    if(this.state.Username===""){
        this.setState({
            Username_err:'* empty User Name! *'
        })  
    }
    else{
        this.setState({
            Username_err:''
        });
    }
    if(this.state.role==='DEFAULT_VALUE'){
        this.setState({
            role_err:'* empty Role! *'
           
        })
    }
    else{
        this.setState({
            role_err:''
        })
    }
    return true;
}
handleChange=(e)=>{
  
    this.setState({
        [e.target.id]:e.target.value
     })
     
    }
// }


 handleSubmit = event =>{
     event.preventDefault();
  
  if(this.validate()){
    console.log(this.state);
   }

}
    render(){
        return (
     <div className="card hoverable">
                          <div className="card-content offset-l2"  style={{padding:40}}>
                            <span className="card-title center">Add Member</span>
                            <hr/>
                            <div className="row">
                                <div className="col-12" style={{marginTop:10}}>
                                    <form onSubmit={this.handleSubmit}>
                                    <div className="row">
                                        <div className="input-field col s6">
                                        <input placeholder="Enter First Name" id="firstName" type="text" className="validate" value={this.state.firstName} onChange={this.handleChange}/>
                                        <label className="active" htmlFor="firstName">First Name</label>
                                        <div style={{fontSize:12 ,color:"red"}}>{this.state.firstName_err}</div>
                                        </div>
                                        <div className="input-field col s6">
                                        <input placeholder="Enter Last Name" id="lastName" type="text" className="validate" value={this.state.lastName} onChange={this.handleChange}/>
                                        <label className="active" htmlFor="lastName">Last Name</label>
                                        <div style={{fontSize:12 ,color:"red"}}>{this.state.lastName_err}</div>
                                        </div>
                                        
                                    </div>
                                    <div className="row">
                                    <div className="input-field col s12">
                                        <input id="email" placeholder="Enter Email" type="email" className="validate" value={this.state.email} onChange={this.handleChange}/>
                                        <label className="active" htmlFor="email">Email</label>
                                        <div style={{fontSize:12 ,color:"red"}}>{this.state.email_err}</div>
                                        </div>
                                    </div>
                                    <div className="row">
                                    <div className="input-field col s12">
                                        <input id="mobile" placeholder="Enter Mobile Number" type="Number" className="validate" value={this.state.mobile} onChange={this.handleChange}/>
                                        <label className="active" htmlFor="mobile_no">Mobile Number</label>
                                        <div style={{fontSize:12 ,color:"red"}}>{this.state.mobile_err}</div>
                                        </div>
                                    </div>
                                    <div className="row">
                                    <div className="input-field col s12">
                                        <input id="Username" placeholder="Enter User Name" type="text" className="validate" value={this.state.Username} onChange={this.handleChange}/>
                                        <label className="active" htmlFor="User_name">Enter User Name</label>
                                        <div style={{fontSize:12 ,color:"red"}}>{this.state.Username_err}</div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="input-field col s12">
                                        <select defaultValue="DEFAULT_VALUE" id="role" value={this.state.role} onChange={this.handleChange}>
                                            <option value={"DEFAULT_VALUE"}>Select Role</option>
                                            <option value="1"> Owner</option>
                                            <option value="2">Manager </option>
                                            <option value="3">Advisor </option>
                                            <option value="3">Master </option>
                                            </select>
                                            <label className="active">Role</label>
                                            <div style={{fontSize:12 ,color:"red"}}>{this.state.role_err}</div>
                                        </div>
                                        
                                    </div>
                                    <div className="row">
                                <div className="col-4 center">
                            <button className="btn waves-effect waves-light blue darken-1 " type="submit" name="action">Add<i className="material-icons right">add</i>
                                </button>
                                </div> 
                                </div> 
                                    </form>
                                    </div>
                                  </div>
        
                            </div>
                            </div>
                            
         )}

}

export default AddMember;
